import { combineReducers } from 'redux'
import shipmentTypes from './shipment-types'
export default combineReducers({
  shipmentTypes,
})
